import { buildLabel } from 'src/utilities/naming';
// constant component intents
export const CO_APPLICANT = 'CO_APPLICANT';
export const QUESTION_MULTIPLE = 'MULTIPLE';
export const QUESTION_ACKNOWLEDGE = 'ACKNOWLEDGE';
export const QUESTION_UPSELL_MULTIPLE = 'UPSELL_MULTIPLE';
export const QUESTION_UPSELL_MULTI_CHECKBOX = 'UPSELL_MULTI_CHECKBOX';
export const QUESTION_MULTIPLE_LONG = 'MULTIPLE_LONG';
export const QUESTION_MULTIPLE_LONG_UW = 'MULTIPLE_LONG_UW';
export const WELCOME_INTENT = 'WELCOME';
export const INTENT_QUESTION = 'QUESTION';
export const PRODUCT_TILE = 'PRODUCT_TILE';
export const SLIDER_NUMBER = 'SLIDER_NUMBER';
export const MULTI_INPUT_SLIDER_NUMBER = 'MULTI_INPUT_SLIDER_NUMBER';
export const DROPDOWN = 'DROPDOWN';
export const SEARCH_DROPDOWN = 'SEARCH_DROPDOWN';
export const SLIDER_AMOUNT = 'SLIDER_AMOUNT';
export const SLIDER_PERCENTAGE_AMOUNT = 'SLIDER_PERCENTAGE_AMOUNT';
export const SLIDER_PERCENTAGE = 'SLIDER_PERCENTAGE';
export const SLIDER_MONTHLY_PAYMENT = 'SLIDER_MONTHLY_PAYMENT';
export const SSN_QUESTION = 'SSN_QUESTION';
export const EIN_QUESTION = 'EIN_QUESTION';
export const LOAN_INTENT = 'LOAN_INTENT';
export const ADVISOR_INTENT = 'ADVISOR_INTENT';
export const INTENT_TEXT = 'TEXT';
export const MULTI_TEXT_INPUT = 'MULTI_TEXT_INPUT';
export const MULTI_CHECKBOX = 'MULTI_CHECKBOX';
export const INTENT_ADDRESS = 'ADDRESS';
export const PHONE_NUMBER_TEXT = 'PHONE_NUMBER';
export const PHONE_NUMBER_WITH_OTP_AUTH = 'PHONE_NUMBER_WITH_OTP_AUTH';
export const EMPLOYER_INTENT_ADDRESS = 'EMPLOYER_INTENT_ADDRESS';
export const BUSINESS_INTENT_ADDRESS = 'BUSINESS_INTENT_ADDRESS';
export const BUSINESS_INTENT_ADDRESS_WITH_MIDDESK = 'BUSINESS_INTENT_ADDRESS_WITH_MIDDESK';

export const BUSINESS_MAILING_INTENT_ADDRESS = 'BUSINESS_MAILING_INTENT_ADDRESS'
export const BUSINESS_OWNER_ADDRESS = 'BUSINESS_OWNER_ADDRESS';
export const PROPERTY_ADDRESS_INTENT = 'PROPERTY_ADDRESS_INTENT';
export const PROPERTY_ADDRESS_INTENT_WITHOUT_HOUSE_APPRAISER =
  'PROPERTY_ADDRESS_INTENT_WITHOUT_HOUSE_APPRAISER';
export const CO_BORROWER_INTENT = 'CO_BORROWER_INTENT';
export const INTENT_FORMER_ADDRESS = 'INTENT_FORMER_ADDRESS';
export const TEXT_DATE = 'TEXT_DATE';
export const SUMMARY_INTENT = 'SUMMARY_INTENT';
export const ASAPPLICANT_LOCATE_HOME = 'ASAPPLICANT_LOCATE_HOME';
export const ISO_DROP_DOWN = 'ISO_DROP_DOWN';
export const NAIC_DROPDOWN = 'NAIC_DROPDOWN';
export const FUNDER_APPLICATIONS = 'FUNDER_APPLICATIONS';
export const MULTI_INPUT_OTHER_FUNDER_APPLICATION =
  'MULTI_INPUT_OTHER_FUNDER_APPLICATION';
export const MULTI_INPUT_SAVE_NAME = 'MULTI_INPUT_SAVE_NAME';
export const DOCUMENTS = 'DOCUMENTS';
export const MULTI_ACCOUNT_INPUTS = 'MULTI_ACCOUNT_INPUTS';
export const MULTIPLE_RESOURCE_INPUTS = 'MULTIPLE_RESOURCE_INPUTS';
export const SINGLE_RESOURCE_MULTIPLE_INPUTS = 'SINGLE_RESOURCE_MULTIPLE_INPUTS'
export const SINGLE_RESOURCE_MULTIPLE_RECORDS = 'SINGLE_RESOURCE_MULTIPLE_RECORDS';
export const MULTI_INPUT_PAYOFF_DEBIT = 'MULTI_INPUT_PAYOFF_DEBIT';
export const DECLARATION_INTENT = 'DECLARATION_INTENT';
export const DEMOGRAPHIC_INTENT = 'DEMOGRAPHIC_INTENT';
export const DEMOGRAPHIC_INTENT_INFO = 'DEMOGRAPHIC_INTENT_INFO';
export const FALSE = 'false';
export const TRUE = 'true';
export const MATIC_TYPE_CREDIT_REPORT = 'CREDIT_REPORT';
export const INFO_TEXT = 'INFO_TEXT';
export const INFO_TEXT_BOX = 'INFO_TEXT_BOX';
export const ADVISORS_BY_PERSONA = 'ADVISORS_BY_PERSONA';
export const BUSINESS_OWNERS = 'BUSINESS_OWNERS';
export const CONSENT_INTENT = 'CONSENT_INTENT';
export const SLIDER_CALCULATED_AMOUNT = 'SLIDER_CALCULATED_AMOUNT';
export const OTHER_VALUE = "Other";
export const INTENT_BOT_DOC = "botDoc";
export const RESOURCE_MIDDESK = "middesk";

export const ON_BEHALF_CO_APPLICANT = 'ON_BEHALF_CO_APPLICANT';
export const ON_BEHALF_CO_APPLICANT_LONG = 'ON_BEHALF_CO_APPLICANT_LONG';
export const CREATE_CO_APPLICANT = 'CREATE_CO_APPLICANT';
export const SIGN_UP = 'SIGN_UP';
export const CARD_INTENT = 'CARD_INTENT';
export const HOUSE_APPRAISER = 'HOUSE_APPRAISER';


// Standard question key_fields 
export const DO_YOU_ANSWER_ONBEHALF_CO = 'do_u_answer_on_behalf_co'

// Key Field Constants

export const IS_API_UPDATE = buildLabel('is_api_update');
export const PERSONA_TYPE = buildLabel('persona_type');
export const LENDSMART_SH_API_RESOURCE_WRITE = buildLabel('api_resource_write');
export const LENDSMART_SH_API_RESOURCE_READ = buildLabel('api_resource_read');
export const LENDSMART_SH_FIELD = buildLabel('field');
export const LENDSMART_SH_PRE_SIGN_FIELD = buildLabel('presign_field');
export const LENDSMART_SH_VALUE = buildLabel('value');
export const LENDSMART_SH_API_DECLINE = buildLabel('loanapp_autodecline');
export const MATIC_INTENT = 'matic_intent';
export const PLEASE_CONTINUE_NEXT = 'Please continue with the next step.';
export const PLEASE_REVIEW_NEXT =
  'Please review all of your information below before you continue to the next step.';
export const SUFFIX = [
  { label: 'None', value: '' },
  { label: 'SR', value: 'SR' },
  { label: 'JR', value: 'JR' },
  { label: 'I', value: 'I' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'ESQ', value: 'ESQ' },
];
export const IS_W2_1099 = 'is_w2_1099';
export const EMPLOYER = 'employer';
export const INCOME_VALUE = 'income_value';
export const INTENT_RESP_HEIGHT = 'calc(95vh - 340px)';
export const INTENT_RESP_HEIGHT_MD = 'calc(95vh - 255px)';
export const INTENT_RESP_HEIGHT_SM = 'calc(95vh - 235px)';
export const SUBMIT = 'submit';

export const IS_HIDE_THIS_INTENT = 'is_hide_this_intent';
export const SHOULD_HIDE_STEPPER = 'should_hide_stepper';
export const SHOULD_HIDE_PROGRESS = 'should_hide_progress';
export const DE_ACTIVATED_UPON = 'de_activated_upon';
export const IS_MASK_THIS_INTENT_COND = 'is_mask_this_intent_cond';
export const QUESTION_TYPE = 'question_type';
export const INTENT_TYPE = 'intent_type';
export const QUESTION_ID = 'question_id';
export const KEY_FIELD = 'key_field';
export const ANSWER = 'answer';
export const SHOULD_SOFT_DECLINE = 'should_soft_decline';
export const RULE_CONTEXT = 'rule_context'
